import { urlFor } from "@lib/sanity";

export const getImages = (img) => {
  const imageLarge = urlFor(img)
    .auto("format")
    .fit("max")
    .url();
  const imageMedium = urlFor(img)
    .auto("format")
    .fit("max")
    .url();
  const imageSmall = urlFor(img)
    .auto("format")
    .fit("max")
    .url();
  return { large: imageLarge, medium: imageMedium, small: imageSmall };
};